import { motion } from "framer-motion";
import { ArrowUpRight, Globe, Lock } from "lucide-react";
import { PROJECTS } from "./data";

const reveal = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
};

export const Portfolio = () => {
  return (
    <section id="portfolio" data-testid="portfolio-section" className="relative py-28 px-5">
      <div className="max-w-7xl mx-auto">
        <motion.div {...reveal} transition={{ duration: 0.6 }} className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <p className="font-mono text-xs tracking-[0.3em] uppercase overline mb-4">
              / Selected Work
            </p>
            <h2 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight txt-primary">
              Live systems, shipped.
            </h2>
          </div>
          <p className="txt-soft max-w-sm">
            Real products in the wild — plus a growing pipeline of builds under
            active development.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {PROJECTS.map((p, i) => {
            const Card = p.url ? "a" : "div";
            return (
              <motion.div key={p.id} {...reveal} transition={{ duration: 0.6, delay: i * 0.1 }}>
                <Card
                  {...(p.url ? { href: p.url, target: "_blank", rel: "noopener noreferrer" } : {})}
                  data-testid={`portfolio-card-${p.id}`}
                  className="group relative flex flex-col h-full overflow-hidden rounded-3xl glass p-7 hover:border-purple-500/50 transition-all duration-300"
                >
                  <div className="absolute -top-24 -right-24 w-48 h-48 rounded-full bg-purple-600/20 blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  <div className="relative flex items-center justify-between">
                    <span className={`inline-flex items-center gap-1.5 font-mono text-[11px] px-2.5 py-1 rounded-full border ${p.live ? "border-emerald-400/30 text-emerald-500 bg-emerald-500/10" : "border-amber-400/30 text-amber-500 bg-amber-500/10"}`}>
                      {p.live ? <Globe className="w-3 h-3" /> : <Lock className="w-3 h-3" />}
                      {p.live ? "Live" : "In build"}
                    </span>
                    {p.url && (
                      <ArrowUpRight className="w-5 h-5 txt-dim group-hover:txt-primary group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
                    )}
                  </div>

                  <h3 className="relative font-heading text-2xl font-bold txt-primary mt-8">
                    {p.name}
                  </h3>
                  <p className="relative font-mono text-xs overline mt-1.5">{p.domain}</p>
                  <p className="relative text-sm overline mt-4 opacity-80">{p.category}</p>
                  <p className="relative txt-soft mt-2 leading-relaxed flex-grow">{p.desc}</p>
                  <div className="relative mt-6 flex flex-wrap gap-2">
                    {p.tags.map((t) => (
                      <span key={t} className="font-mono text-[11px] px-2.5 py-1 rounded-md chip">
                        {t}
                      </span>
                    ))}
                  </div>
                </Card>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
